import { cn } from '@/lib/utils'

export function TabButton({
  active,
  count,
  onClick,
  children,
}: {
  active: boolean
  count?: number
  onClick: () => void
  children: React.ReactNode
}) {
  return (
    <button
      type="button"
      role="tab"
      aria-selected={active}
      onClick={onClick}
      className={cn(
        '-mb-px whitespace-nowrap border-b-2 px-3.5 py-2.5 text-sm transition-colors',
        active
          ? 'border-[var(--fl-heading)] font-semibold text-[var(--fl-heading)]'
          : 'border-transparent font-medium text-[var(--fl-text-2)] hover:text-[var(--fl-heading)]'
      )}
    >
      {children}
      {count !== undefined && (
        <span className="ml-1 text-xs font-normal text-[var(--fl-text-3)]">{count}</span>
      )}
    </button>
  )
}
